export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "Abrir centro de guías",
    fabLabel: "Guías",
    assistantAria: "Asistente de guías",
    dontShowAgain: "No volver a mostrar",
    centerAria: "Centro de guías",
    eyebrow: "CENTRO DE GUÍAS",
    title: "Aprende WACheckin",
    watchedOf: "{watched} de {total} vistas",
    close: "Cerrar",
    searchPlaceholder: "Buscar una guía…",
    forThisScreen: "Para esta pantalla",
    watched: "Vista",
    watchGuide: "Ver guía",
    comingSoon: "Próximamente: nuevas mejoras y actualizaciones.",
    noResults: "Sin resultados para “{query}”.",
    needHelp: "¿Necesitas ayuda? ",
    contactWhatsApp: "Escríbenos por WhatsApp",
    lightboxMeta: "{section} · Guía {n} de {total}",
    videoTitle: "Video guía",
    playerAria: "Reproductor de guía",
    prev: "Anterior",
    watchOnYouTube: "Ver en YouTube",
    next: "Siguiente",
    sections: {
      inicio: "Primeros pasos",
      alojamiento: "Tu alojamiento",
      tarifas: "Tarifas y canales",
      calendario: "Calendario y reservas",
      huesped: "Experiencia del huésped",
      autoridades: "Autoridades",
      novedades: "Novedades",
    },
    videos: {
      navigate: "Acceder y navegar por las configuraciones",
      propertyData: "Datos, ubicación y branding de tu alojamiento",
      checkinWelcome: "Check-in, mensaje de bienvenida y políticas",
      basePrices: "Precios base y tarifas derivadas por canal",
      calendar: "Calendario: reservas, disponibilidad y precios",
      guestJourney: "El recorrido del huésped: mensajes, códigos y automatizaciones",
      guestVerification: "Verificación del huésped y solicitud de reseñas",
      authorities: "Conectar autoridades y enviar partes de viajeros",
    },
    ai: {
      cta: "Ver la lista de vídeos",
      assistant: "Asistente",
      inicio: "¿Primer día por aquí? Te enseño lo básico en 2 minutos.",
      alojamiento: "¿Configurando tu alojamiento? Mira cómo dejarlo perfecto.",
      tarifas: "¿Dudas con los precios? Te explico las tarifas por canal.",
      calendario: "¿Quieres dominar el calendario? Reservas, precios y disponibilidad.",
      huesped: "¿Automatizamos el recorrido del huésped? Te lo enseño paso a paso.",
      autoridades: "¿Conectamos las autoridades? Envía los partes de viajeros en 1 vídeo.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "Novedades del sistema",
    latestUpdates: "Últimas actualizaciones",
    close: "Cerrar",
    tabNews: "Novedades",
    reports: "Reportes",
    loading: "Cargando…",
    emptyNews: "Aún no hay novedades. Aquí verás las mejoras en cuanto las publiquemos.",
    showMore: "Ver más",
    showLess: "Ver menos",
    reportProblem: "Reportar un problema",
    emptyReports: "Aún no has enviado ningún reporte.",
    sendReport: "+ Enviar un reporte",
    sendNewReport: "+ Enviar un nuevo reporte",
    capturesCount: "{count} captura | {count} capturas",
    viewConversation: "Ver conversación →",
    new: "Nuevo",
    openedOn: "abierto el {date}",
    conversationWithSupport: "Conversación con el equipo de soporte",
    you: "Tú",
    support: "Soporte",
    noReplyYet: "Nadie del equipo ha respondido todavía. Te avisamos aquí en cuanto lo hagan.",
    replyPlaceholder: "Escribe tu respuesta…",
    send: "Enviar",
    replyHint: "<b>Enter</b> envía · <b>Mayús + Enter</b> salta de línea",
    back: "Volver",
    sendReportTitle: "Enviar un reporte",
    formSubtitle: "Cuéntanos qué ha pasado y lo revisamos. Verás la respuesta en tus reportes.",
    about: "Sobre",
    whatHappens: "¿Qué ocurre?",
    titlePlaceholder: "Resúmelo en una frase",
    describeDetail: "Descríbelo con detalle",
    descPlaceholder: "Qué esperabas, qué pasó y cómo reproducirlo.",
    capture: "Captura",
    optional: "opcional",
    attachHint: "Pulsa para adjuntar una imagen",
    sending: "Enviando…",
    submitReport: "Enviar reporte",
    prev: "Anterior",
    next: "Siguiente",
    today: "Hoy",
    yesterday: "Ayer",
    status: {
      open: "Abierta",
      in_progress: "En progreso",
      resolved: "Resuelta",
      closed: "Cerrada",
    },
    errRequired: "Cuéntanos qué ocurre.",
    errSend: "No se pudo enviar. Inténtalo de nuevo.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "Verificación de Identidad",
    subtitle: "Para completar tu check-in, necesitamos verificar tu identidad",
    idDocument: "Documento de Identidad",
    idDocumentDesc: "Toma una foto clara del frente de tu documento (DNI, NIE, cédula, pasaporte o licencia)",
    selfie: "Selfie",
    selfieDesc: "Toma una selfie donde se vea claramente tu rostro",
    requirements: "Requisitos:",
    req1: "Buena iluminación",
    req2: "Documento completo en el marco",
    req3: "Texto legible",
    req4: "Selfie sin accesorios que oculten el rostro",
    start: "Comenzar Verificación",
    frontTitle: "Frontal del documento",
    alignDocument: "Alinea tu documento dentro del marco",
    hintLegible: "Asegúrate que todos los datos sean legibles",
    faceTitle: "Verificación Facial",
    alignFace: "Alinea tu rostro dentro del círculo",
    hintLookCamera: "Mira directamente a la cámara sin accesorios",
    reviewTitle: "Revisa tus fotos",
    reviewSubtitle: "Verifica que todas las imágenes sean claras y legibles",
    frontDocTitle: "Documento frontal",
    retake: "Volver a tomar",
    back: "Volver",
    submit: "Enviar para verificación",
    processingTitle: "Verificando tu identidad",
    processingDesc: "Estamos validando tus documentos. Esto puede tomar unos segundos...",
    dontClose: "No cierres esta ventana",
    successTitle: "¡Verificación exitosa!",
    successDesc: "Tu identidad ha sido verificada correctamente.",
    continue: "Continuar",
    errorTitle: "Error en verificación",
    couldNotVerify: "No pudimos verificar tu identidad. Por favor intenta nuevamente.",
    retry: "Reintentar",
    cameraErrorTitle: "Error al acceder a la cámara",
    cameraErrorDesc: "No pudimos acceder a tu cámara. Por favor verifica los permisos e intenta nuevamente.",
    suggestions: "Sugerencias:",
    tip1: "Asegúrate de haber concedido permisos para usar la cámara",
    tip2: "Verifica que ninguna otra aplicación esté usando la cámara",
    tip3: "Reinicia tu navegador si el problema persiste",
    tryAgainCamera: "Intentar nuevamente",
    couldNotVerifyShort: "No pudimos verificar tu identidad",
    serverError: "Error en el servidor",
    tryLater: "Por favor intenta nuevamente más tarde",
  },
};
